var _polygon, _polygon2, _polygon3, _rect, _polygon4, _rect2, _polygon5, _rect3, _polygon6, _polygon7;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmployees(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "freepik--background-complete--inject-72"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 382.4,
    width: 500,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 416.78,
    y: 398.49,
    width: 33.12,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 322.53,
    y: 401.21,
    width: 8.69,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 396.59,
    y: 389.21,
    width: 19.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 52.46,
    y: 390.89,
    width: 43.19,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 104.56,
    y: 390.89,
    width: 6.33,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.47,
    y: 395.11,
    width: 93.68,
    height: 0.25,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237,337.8H43.91a5.71,5.71,0,0,1-5.7-5.71V60.66A5.71,5.71,0,0,1,43.91,55H237a5.71,5.71,0,0,1,5.71,5.71V332.09A5.71,5.71,0,0,1,237,337.8ZM43.91,55.2a5.46,5.46,0,0,0-5.45,5.46V332.09a5.46,5.46,0,0,0,5.45,5.46H237a5.47,5.47,0,0,0,5.46-5.46V60.66A5.47,5.47,0,0,0,237,55.2Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M453.31,337.8H260.21a5.72,5.72,0,0,1-5.71-5.71V60.66A5.72,5.72,0,0,1,260.21,55h193.1A5.71,5.71,0,0,1,459,60.66V332.09A5.71,5.71,0,0,1,453.31,337.8ZM260.21,55.2a5.47,5.47,0,0,0-5.46,5.46V332.09a5.47,5.47,0,0,0,5.46,5.46h193.1a5.47,5.47,0,0,0,5.46-5.46V60.66a5.47,5.47,0,0,0-5.46-5.46Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.55,
    y: 103.37,
    width: 71.25,
    height: 241.71,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "157.19 103.37 153.03 103.37 128.18 345.08 132.34 345.08 157.19 103.37",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.09,
    y: 104.31,
    width: 70.45,
    height: 2.13,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 96.09,
    y: 342.97,
    width: 70.45,
    height: 4.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 98.8,
    y: 347.33,
    width: 66.57,
    height: 0.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "98.8 104.31 165.37 104.31 165.37 347.33 169.36 347.33 169.36 101.32 94.81 101.32 94.81 347.33 98.8 347.33 98.8 104.31",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.84,
    y: 103.37,
    width: 71.25,
    height: 241.71,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "227.32 103.37 204.61 103.37 179.76 345.08 202.47 345.08 227.32 103.37",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.38,
    y: 104.31,
    width: 72.45,
    height: 2.13,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 175.38,
    y: 342.97,
    width: 72.45,
    height: 4.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 178.09,
    y: 347.33,
    width: 66.57,
    height: 0.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "178.09 104.31 244.66 104.31 244.66 347.33 248.64 347.33 248.64 101.32 174.1 101.32 174.1 347.33 178.09 347.33 178.09 104.31",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 255.12,
    y: 103.37,
    width: 69.25,
    height: 241.71,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "294.36 103.37 290.2 103.37 265.35 345.08 269.51 345.08 294.36 103.37",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.67,
    y: 104.31,
    width: 70.45,
    height: 2.13,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 254.67,
    y: 342.97,
    width: 70.45,
    height: 4.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 257.38,
    y: 347.33,
    width: 66.57,
    height: 0.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "257.38 104.31 323.94 104.31 323.94 347.33 327.93 347.33 327.93 101.32 253.39 101.32 253.39 347.33 257.38 347.33 257.38 104.31",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 334.41,
    y: 103.37,
    width: 71.25,
    height: 241.71,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.69 103.37 375.98 103.37 351.12 345.08 373.84 345.08 398.69 103.37",
    style: {
      fill: "#f5f5f5"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.95,
    y: 104.31,
    width: 70.45,
    height: 2.13,
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 333.95,
    y: 342.97,
    width: 70.45,
    height: 4.56,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "336.66 104.31 403.23 104.31 403.23 347.33 407.22 347.33 407.22 101.32 332.68 101.32 332.68 347.33 336.66 347.33 336.66 104.31",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 336.66,
    y: 347.33,
    width: 66.57,
    height: 0.2,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.82,
    y: 289.47,
    width: 30.93,
    height: 53.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "139.81 281.99 139.81 295.41 137.38 295.41 123.2 295.41 120.76 295.41 120.76 281.99 139.81 281.99",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.82,
    y: 291.45,
    width: 3.96,
    height: 3.96,
    transform: "translate(283.59 586.86) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.14,
    y: 291.45,
    width: 3.96,
    height: 3.96,
    transform: "translate(268.25 586.86) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.47,
    y: 291.45,
    width: 3.96,
    height: 3.96,
    transform: "translate(252.91 586.86) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.8,
    y: 291.45,
    width: 3.96,
    height: 3.96,
    transform: "translate(237.57 586.86) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.82,
    y: 298.64,
    width: 3.96,
    height: 3.96,
    transform: "translate(283.59 601.25) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.14,
    y: 298.64,
    width: 3.96,
    height: 3.96,
    transform: "translate(268.25 601.25) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.47,
    y: 298.64,
    width: 3.96,
    height: 3.96,
    transform: "translate(252.91 601.25) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.8,
    y: 298.64,
    width: 3.96,
    height: 3.96,
    transform: "translate(237.57 601.25) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.82,
    y: 305.84,
    width: 3.96,
    height: 3.96,
    transform: "translate(283.59 615.64) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.14,
    y: 305.84,
    width: 3.96,
    height: 3.96,
    transform: "translate(268.25 615.64) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.47,
    y: 305.84,
    width: 3.96,
    height: 3.96,
    transform: "translate(252.91 615.64) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.14,
    y: 285.23,
    width: 3.96,
    height: 3.96,
    transform: "translate(268.25 574.42) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.47,
    y: 285.23,
    width: 3.96,
    height: 3.96,
    transform: "translate(252.91 574.42) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.8,
    y: 305.84,
    width: 3.96,
    height: 3.96,
    transform: "translate(237.57 615.64) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.82,
    y: 313.04,
    width: 3.96,
    height: 3.96,
    transform: "translate(283.59 630.03) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.14,
    y: 313.04,
    width: 3.96,
    height: 3.96,
    transform: "translate(268.25 630.03) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.47,
    y: 313.04,
    width: 3.96,
    height: 3.96,
    transform: "translate(252.91 630.03) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.8,
    y: 313.04,
    width: 3.96,
    height: 3.96,
    transform: "translate(237.57 630.03) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.82,
    y: 320.23,
    width: 3.96,
    height: 3.96,
    transform: "translate(283.59 644.42) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.14,
    y: 320.23,
    width: 3.96,
    height: 3.96,
    transform: "translate(268.25 644.42) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.47,
    y: 320.23,
    width: 3.96,
    height: 3.96,
    transform: "translate(252.91 644.42) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.8,
    y: 320.23,
    width: 3.96,
    height: 3.96,
    transform: "translate(237.57 644.42) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.82,
    y: 327.43,
    width: 3.96,
    height: 3.96,
    transform: "translate(283.59 658.81) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.14,
    y: 327.43,
    width: 3.96,
    height: 3.96,
    transform: "translate(268.25 658.81) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.47,
    y: 327.43,
    width: 3.96,
    height: 3.96,
    transform: "translate(252.91 658.81) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.8,
    y: 327.43,
    width: 3.96,
    height: 3.96,
    transform: "translate(237.57 658.81) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 139.82,
    y: 334.62,
    width: 3.96,
    height: 3.96,
    transform: "translate(283.59 673.21) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 132.14,
    y: 334.62,
    width: 3.96,
    height: 3.96,
    transform: "translate(268.25 673.21) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.47,
    y: 334.62,
    width: 3.96,
    height: 3.96,
    transform: "translate(252.91 673.21) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 116.8,
    y: 334.62,
    width: 3.96,
    height: 3.96,
    transform: "translate(237.57 673.21) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 289.21,
    y: 289.47,
    width: 30.93,
    height: 53.49,
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "314.21 281.99 314.21 295.41 311.77 295.41 297.59 295.41 295.15 295.41 295.15 281.99 314.21 281.99",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.21,
    y: 291.45,
    width: 3.96,
    height: 3.96,
    transform: "translate(632.37 586.86) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.54,
    y: 291.45,
    width: 3.96,
    height: 3.96,
    transform: "translate(617.03 586.86) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.86,
    y: 291.45,
    width: 3.96,
    height: 3.96,
    transform: "translate(601.69 586.86) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.19,
    y: 291.45,
    width: 3.96,
    height: 3.96,
    transform: "translate(586.35 586.86) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.21,
    y: 298.64,
    width: 3.96,
    height: 3.96,
    transform: "translate(632.37 601.25) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.54,
    y: 298.64,
    width: 3.96,
    height: 3.96,
    transform: "translate(617.03 601.25) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.86,
    y: 298.64,
    width: 3.96,
    height: 3.96,
    transform: "translate(601.69 601.25) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.19,
    y: 298.64,
    width: 3.96,
    height: 3.96,
    transform: "translate(586.35 601.25) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.21,
    y: 305.84,
    width: 3.96,
    height: 3.96,
    transform: "translate(632.37 615.64) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.54,
    y: 305.84,
    width: 3.96,
    height: 3.96,
    transform: "translate(617.03 615.64) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.86,
    y: 305.84,
    width: 3.96,
    height: 3.96,
    transform: "translate(601.69 615.64) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.54,
    y: 285.23,
    width: 3.96,
    height: 3.96,
    transform: "translate(617.03 574.42) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.86,
    y: 285.23,
    width: 3.96,
    height: 3.96,
    transform: "translate(601.69 574.42) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.19,
    y: 305.84,
    width: 3.96,
    height: 3.96,
    transform: "translate(586.35 615.64) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.21,
    y: 313.04,
    width: 3.96,
    height: 3.96,
    transform: "translate(632.37 630.03) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.54,
    y: 313.04,
    width: 3.96,
    height: 3.96,
    transform: "translate(617.03 630.03) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.86,
    y: 313.04,
    width: 3.96,
    height: 3.96,
    transform: "translate(601.69 630.03) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.19,
    y: 313.04,
    width: 3.96,
    height: 3.96,
    transform: "translate(586.35 630.03) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.21,
    y: 320.23,
    width: 3.96,
    height: 3.96,
    transform: "translate(632.37 644.42) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.54,
    y: 320.23,
    width: 3.96,
    height: 3.96,
    transform: "translate(617.03 644.42) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.86,
    y: 320.23,
    width: 3.96,
    height: 3.96,
    transform: "translate(601.69 644.42) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.19,
    y: 320.23,
    width: 3.96,
    height: 3.96,
    transform: "translate(586.35 644.42) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.21,
    y: 327.43,
    width: 3.96,
    height: 3.96,
    transform: "translate(632.37 658.81) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.54,
    y: 327.43,
    width: 3.96,
    height: 3.96,
    transform: "translate(617.03 658.81) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.86,
    y: 327.43,
    width: 3.96,
    height: 3.96,
    transform: "translate(601.69 658.81) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.19,
    y: 327.43,
    width: 3.96,
    height: 3.96,
    transform: "translate(586.35 658.81) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 314.21,
    y: 334.62,
    width: 3.96,
    height: 3.96,
    transform: "translate(632.37 673.21) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.54,
    y: 334.62,
    width: 3.96,
    height: 3.96,
    transform: "translate(617.03 673.21) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 298.86,
    y: 334.62,
    width: 3.96,
    height: 3.96,
    transform: "translate(601.69 673.21) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 291.19,
    y: 334.62,
    width: 3.96,
    height: 3.96,
    transform: "translate(586.35 673.21) rotate(180)",
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 341.57,
    y: 308.95,
    width: 27.71,
    height: 34,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.98 312.72 350.42 312.72 352.2 312.72 353.97 312.72 353.97 316.27 352.2 316.27 350.42 316.27 343.98 316.27 343.98 312.72",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.98 319.6 350.42 319.6 352.2 319.6 353.97 319.6 353.97 323.14 352.2 323.14 350.42 323.14 343.98 323.14 343.98 319.6",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.98 326.47 350.42 326.47 352.2 326.47 353.97 326.47 353.97 330.01 352.2 330.01 350.42 330.01 343.98 330.01 343.98 326.47",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "343.98 333.34 350.42 333.34 353.17 333.34 353.97 333.34 353.97 336.89 353.17 336.89 350.42 336.89 343.98 336.89 343.98 333.34",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.87 312.72 363.32 312.72 365.09 312.72 366.86 312.72 366.86 316.27 365.09 316.27 363.32 316.27 356.87 316.27 356.87 312.72",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.87 319.6 363.32 319.6 365.82 319.6 366.86 319.6 366.86 323.14 365.82 323.14 363.32 323.14 356.87 323.14 356.87 319.6",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.87 326.47 363.32 326.47 365.09 326.47 366.86 326.47 366.86 330.01 365.09 330.01 363.32 330.01 356.87 330.01 356.87 326.47",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "356.87 333.34 363.32 333.34 365.09 333.34 366.86 333.34 366.86 336.89 365.09 336.89 363.32 336.89 356.87 336.89 356.87 333.34",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 211.95,
    y: 321.83,
    width: 25.18,
    height: 21.13,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.29,
    y: 324.46,
    width: 3.22,
    height: 3.22,
    transform: "translate(467.8 652.15) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.05,
    y: 324.46,
    width: 3.22,
    height: 3.22,
    transform: "translate(455.31 652.15) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.8,
    y: 324.46,
    width: 3.22,
    height: 3.22,
    transform: "translate(442.83 652.15) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.56,
    y: 324.46,
    width: 3.22,
    height: 3.22,
    transform: "translate(430.34 652.15) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.29,
    y: 330.32,
    width: 3.22,
    height: 3.22,
    transform: "translate(467.8 663.86) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.05,
    y: 330.32,
    width: 3.22,
    height: 3.22,
    transform: "translate(455.31 663.86) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.8,
    y: 330.32,
    width: 3.22,
    height: 3.22,
    transform: "translate(442.83 663.86) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.56,
    y: 330.32,
    width: 3.22,
    height: 3.22,
    transform: "translate(430.34 663.86) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 232.29,
    y: 336.18,
    width: 3.22,
    height: 3.22,
    transform: "translate(467.8 675.57) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 226.05,
    y: 336.18,
    width: 3.22,
    height: 3.22,
    transform: "translate(455.31 675.57) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 219.8,
    y: 336.18,
    width: 3.22,
    height: 3.22,
    transform: "translate(442.83 675.57) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 213.56,
    y: 336.18,
    width: 3.22,
    height: 3.22,
    transform: "translate(430.34 675.57) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 261.39,
    y: 321.83,
    width: 25.18,
    height: 21.13,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.73,
    y: 324.46,
    width: 3.22,
    height: 3.22,
    transform: "translate(566.69 652.15) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.49,
    y: 324.46,
    width: 3.22,
    height: 3.22,
    transform: "translate(554.2 652.15) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.25,
    y: 324.46,
    width: 3.22,
    height: 3.22,
    transform: "translate(541.71 652.15) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 324.46,
    width: 3.22,
    height: 3.22,
    transform: "translate(529.23 652.15) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.73,
    y: 330.32,
    width: 3.22,
    height: 3.22,
    transform: "translate(566.69 663.86) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.49,
    y: 330.32,
    width: 3.22,
    height: 3.22,
    transform: "translate(554.2 663.86) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.25,
    y: 330.32,
    width: 3.22,
    height: 3.22,
    transform: "translate(541.71 663.86) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 330.32,
    width: 3.22,
    height: 3.22,
    transform: "translate(529.23 663.86) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 281.73,
    y: 336.18,
    width: 3.22,
    height: 3.22,
    transform: "translate(566.69 675.57) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 275.49,
    y: 336.18,
    width: 3.22,
    height: 3.22,
    transform: "translate(554.2 675.57) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 269.25,
    y: 336.18,
    width: 3.22,
    height: 3.22,
    transform: "translate(541.71 675.57) rotate(180)",
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 263,
    y: 336.18,
    width: 3.22,
    height: 3.22,
    transform: "translate(529.23 675.57) rotate(180)",
    style: {
      fill: "#e6e6e6"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 183.36,
    y: 306.2,
    width: 25.18,
    height: 36.75,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.46,
    y: 307.82,
    width: 9.47,
    height: 9.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.97,
    y: 307.82,
    width: 9.47,
    height: 9.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.46,
    y: 319.53,
    width: 9.47,
    height: 9.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.97,
    y: 319.53,
    width: 9.47,
    height: 9.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.46,
    y: 331.24,
    width: 9.47,
    height: 9.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 184.97,
    y: 331.24,
    width: 9.47,
    height: 9.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 373.49,
    y: 306.2,
    width: 25.18,
    height: 36.75,
    style: {
      fill: "#f0f0f0"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.59,
    y: 307.82,
    width: 9.47,
    height: 9.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.1,
    y: 307.82,
    width: 9.47,
    height: 9.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.59,
    y: 319.53,
    width: 9.47,
    height: 9.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.1,
    y: 319.53,
    width: 9.47,
    height: 9.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 387.59,
    y: 331.24,
    width: 9.47,
    height: 9.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 375.1,
    y: 331.24,
    width: 9.47,
    height: 9.08,
    style: {
      fill: "#fafafa"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M83.39,356.08s-5.06-11,.72-21.94,7.47-13.45,3.78-15.69-5.38,8.72-5.38,8.72A24.58,24.58,0,0,1,82,311.76c2.56-7.88,4.17-20.71.67-22.09s-.67,16-3.72,21.94a51.16,51.16,0,0,1-3-12.93c-.42-6.33.24-16.44-2.53-19s-4.54-.8-1.82,13.17a146.18,146.18,0,0,1,2.7,25.32s-6-18.32-10-18.86-4,5.4-.57,10.55,10.11,14.37,11.2,19.11c0,0-6.6-13.79-12.53-9.56s5.17,12.55,10.11,15.56,8.38,21.87,8.38,21.87Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M79.39,360.61s4.93-11.12-1-21.92-7.63-13.35-4-15.63,5.48,8.63,5.48,8.63,3-7.58.36-15.42-4.43-20.65-.94-22.08.86,16,4,21.88a51.13,51.13,0,0,0,2.83-13c.34-6.33-.44-16.43,2.3-19.06s4.53-.87,2,13.14A146.84,146.84,0,0,0,88,322.54s5.79-18.41,9.82-19,4.09,5.33.7,10.53-9.94,14.52-11,19.28c0,0,6.43-13.89,12.41-9.75s-5,12.63-9.92,15.71-8.12,22-8.12,22Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "102.14 352.69 61.4 352.69 64.7 381.83 98.84 381.83 102.14 352.69",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.48,350.61c.15-1,3.52-24.29-3.24-32.34a7.32,7.32,0,0,0-5.62-2.76c-13.66-.32-15.53,10.65-15.55,10.76l1.62.25c.06-.4,1.68-9.68,13.89-9.38a5.66,5.66,0,0,1,4.41,2.18c6.3,7.49,2.91,30.82,2.88,31.05Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.3,349.55l1.63-.05c0-.22-.54-21.48,9.94-25.87,10.26-4.3,14.88,4.54,15.07,4.92l1.46-.73c-.06-.1-5.47-10.59-17.16-5.69C407.73,327,408.28,348.63,408.3,349.55Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M408.26,351.22c0-.34.1-34,6.65-43.8,6.29-9.44,16.45-5,16.88-4.8l.67-1.48c-.12-.06-11.83-5.23-18.91,5.38-6.82,10.24-6.92,43.29-6.92,44.7Z",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.66,316.31s6,2.2,4.19,7.39-20.63,13.73-20.63,13.73-7.89-7.23-.64-19S396.5,312.6,396.66,316.31Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M415.21,305.65s-4.24-.45-3.9-3,16.46-9.22,26,1.52c0,0-6.09,10.46-14.89,10.59S415.21,305.65,415.21,305.65Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M419.55,322.88s-2.92-2.36.23-3.51,18.63-.82,18.79,14.5c0,0-18,3-20.25-2.84S419.55,322.88,419.55,322.88Z",
    style: {
      fill: "#e0e0e0"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "393.46 381.83 421.43 381.83 424.44 351.22 390.44 351.22 393.46 381.83",
    style: {
      fill: "#ebebeb"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 388.95,
    y: 347.84,
    width: 36.99,
    height: 6.76,
    transform: "translate(814.88 702.43) rotate(180)",
    style: {
      fill: "#e0e0e0"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Shadow--inject-72"
  }, /*#__PURE__*/React.createElement("ellipse", {
    id: "freepik--path--inject-72",
    cx: 250,
    cy: 416.24,
    rx: 193.89,
    ry: 11.32,
    style: {
      fill: "#f5f5f5"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-3--inject-72"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "398.57 408.08 406.04 408.92 405.11 386.86 396.2 388.12 398.57 408.08",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.57 408.34 367.1 407.59 369.02 388.24 360.02 388.24 359.57 408.34",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "398.57 408.08 406.04 408.92 405.11 386.86 396.2 388.12 398.57 408.08",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "359.57 408.34 367.1 407.59 369.02 388.24 360.02 388.24 359.57 408.34",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.52,245.12s-.76,5-1.16,5-5-4.42-5-4.42l3.09-4.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M396.52,245.12s-.76,5-1.16,5-5-4.42-5-4.42l3.09-4.28Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.46,185.72c4.53,1,17.78,30.57,19,35.26s-10.29,26.32-10.29,26.32l-5.53-6.11L398,221l-10.5-18.59Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M388.46,185.72c4.53,1,17.78,30.57,19,35.26s-10.29,26.32-10.29,26.32l-5.53-6.11L398,221l-10.5-18.59Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M407.26,407H398a.67.67,0,0,0-.65.52l-1.56,6.73a1.09,1.09,0,0,0,1.1,1.34c3-.05,5.13-.22,8.87-.22,2.31,0,9.24.24,12.42.24s3.62-3.14,2.33-3.43c-5.82-1.27-10.2-3-12.05-4.71A1.85,1.85,0,0,0,407.26,407Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M367.24,245.86s2.75,14.33,6.19,31.56c2,9.93,4.2,20.81,6.24,30.49.74,3.48,1.45,6.8,2.13,9.87,5.2,23.6,14.66,86.1,14.66,86.1l11.73-1.94s-2.33-67.93-6.05-92c-3.39-22-10.25-72.85-10.25-72.85Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M373.43,277.42c2,9.93,4.2,20.81,6.24,30.49a76.57,76.57,0,0,0-3-39.07A60.75,60.75,0,0,0,373.43,277.42Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.24,407H359a.67.67,0,0,0-.65.52l-1.56,6.73a1.09,1.09,0,0,0,1.09,1.34c3-.05,5.14-.22,8.88-.22,2.3,0,9.24.24,12.42.24s3.62-3.14,2.32-3.43c-5.82-1.27-10.2-3-12.05-4.71A1.82,1.82,0,0,0,368.24,407Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.92,238.12s-.34,51.36-.06,73.57c.31,24.32-7.06,92-7.06,92l-11.86-1s-.47-62-2.31-86.09c-2.06-26.94-3.64-73.39-3.64-73.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,245.12c0-4-.5-10.35-.66-15.88-.15-5.07-.45-10.68-1-16.55a169.82,169.82,0,0,0-4.23-25s4.79-1.25,10.22-2.06c1.06-.16,2.16-.3,3.24-.42a150.79,150.79,0,0,1,17.2-1c.71,0,1.41.05,2.09.11a78.61,78.61,0,0,1,9.64,1.32s8.84,19.78,4.46,57.94Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M352,245.12c0-4-.5-10.35-.66-15.88-.15-5.07-.45-10.68-1-16.55a169.82,169.82,0,0,0-4.23-25s4.79-1.25,10.22-2.06c1.06-.16,2.16-.3,3.24-.42a150.79,150.79,0,0,1,17.2-1c.71,0,1.41.05,2.09.11a78.61,78.61,0,0,1,9.64,1.32s8.84,19.78,4.46,57.94Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M348.66,200.19c.71,4.24,1.23,8.43,1.64,12.5.07.7.13,1.39.19,2.08A36.14,36.14,0,0,0,352,201.59,8.86,8.86,0,0,0,348.66,200.19Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.34,165.81c1.34,5.47,2.9,15.54-.8,19.44a17.07,17.07,0,0,0,13.5,4.53c4.76-.38,4.84-3.71,3.69-5.5-6.24-1.12-6.29-5.7-5.41-10.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M360.34,165.81c1.34,5.47,2.9,15.54-.8,19.44a17.07,17.07,0,0,0,13.5,4.53c4.76-.38,4.84-3.71,3.69-5.5-6.24-1.12-6.29-5.7-5.41-10.06Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M364.81,169.24l6.5,5a18.28,18.28,0,0,0-.39,3.08c-2.37-.21-5.73-2.61-6.09-5.07A8.24,8.24,0,0,1,364.81,169.24Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.63,158.49c1.84,7.38,2.54,11.8,7,14.9,6.75,4.66,15.33-.56,15.73-8.37.36-7-2.71-17.92-10.57-19.46A10.49,10.49,0,0,0,357.63,158.49Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.63,158.49c1.84,7.38,2.54,11.8,7,14.9,6.75,4.66,15.33-.56,15.73-8.37.36-7-2.71-17.92-10.57-19.46A10.49,10.49,0,0,0,357.63,158.49Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.34,158.37c.11.61.53,1,.92,1s.63-.64.52-1.24-.53-1-.92-1S369.23,157.76,369.34,158.37Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.21,157c.12.61.53,1,.93,1s.63-.63.51-1.24-.52-1-.92-1S376.1,156.41,376.21,157Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M374.09,157.75a21.28,21.28,0,0,0,3.88,4.44,3.68,3.68,0,0,1-2.8,1.06Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M372.34,166.21a4.6,4.6,0,0,0,.8-.1.18.18,0,0,0,.15-.21.19.19,0,0,0-.21-.15,4.88,4.88,0,0,1-4.28-1.11.18.18,0,0,0-.26,0,.19.19,0,0,0,0,.26A5,5,0,0,0,372.34,166.21Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M366.81,156.56a.37.37,0,0,0,.31-.2,2.91,2.91,0,0,1,2.06-1.64.37.37,0,0,0,.32-.41.36.36,0,0,0-.4-.32,3.67,3.67,0,0,0-2.63,2,.35.35,0,0,0,.16.48A.39.39,0,0,0,366.81,156.56Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M378.74,154.08a.48.48,0,0,0,.2-.07.37.37,0,0,0,.07-.51,3.53,3.53,0,0,0-2.94-1.51.36.36,0,0,0-.34.38.35.35,0,0,0,.38.34,2.84,2.84,0,0,1,2.32,1.22A.33.33,0,0,0,378.74,154.08Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M368.15,150.2s-2.35-1.06-3,.71.28,6,.28,6l-.57-.67s-.77,9.94-5.08,8.33S348,154.5,356,147.85c0,0,.5-2.46,6.2-4.75s13.59-.06,15.59,3.61.72,6.2.72,6.2a5.78,5.78,0,0,0-1.6-2.1,2.51,2.51,0,0,1-1.12,2.1,4.42,4.42,0,0,0-.94-2.22,5,5,0,0,1-.62,2.08c-1.23-3.94-4.13-4.22-5-4A1.5,1.5,0,0,0,368.15,150.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.9,165.25a7.13,7.13,0,0,0,4.27,3.47c2.43.69,3.69-1.49,3-3.81-.58-2.08-2.55-4.95-5-4.63A3.28,3.28,0,0,0,355.9,165.25Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.9,165.25a7.13,7.13,0,0,0,4.27,3.47c2.43.69,3.69-1.49,3-3.81-.58-2.08-2.55-4.95-5-4.63A3.28,3.28,0,0,0,355.9,165.25Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M376.44,188.8l-.93,3.56s4.11,22.33,4.86,34.08l-1.78,3L376,226.84s-.64-30.32-1.7-34.41l-3.1-2.77,2.38-2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.6 187.35 360.08 181.02 356.29 185.67 367.97 194.34 374.08 188.54 380.99 192.96 379.89 184.48 371.95 181.02 373.6 187.35",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "373.6 187.35 360.08 181.02 356.29 185.67 367.97 194.34 374.08 188.54 380.99 192.96 379.89 184.48 371.95 181.02 373.6 187.35",
    style: {
      fill: "#fff",
      opacity: 0.9
    }
  }), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    points: "386.39 247.06 364.42 248.25 364.24 245.63 386.18 244.73 386.39 247.06"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    points: "363.13 245.68 363.37 248.31 352.2 248.92 352.1 246.13 363.13 245.68"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    points: "387.49 244.67 392.89 244.45 393.19 246.69 387.68 246.99 387.49 244.67"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M379.42,245.26l.2,2.12a.56.56,0,0,1-.53.6l-4.38.15a.54.54,0,0,1-.56-.51l-.17-2.09a.56.56,0,0,1,.53-.6l4.34-.17A.56.56,0,0,1,379.42,245.26Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.76,250l-1.91-5c-1-2.17-4.4-.16-4.4-.16a.79.79,0,0,0-.41.86l2.57,9.61a1.35,1.35,0,0,0,2.32.51l.94-1A4.73,4.73,0,0,0,397.76,250Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M397.76,250l-1.91-5c-1-2.17-4.4-.16-4.4-.16a.79.79,0,0,0-.41.86l2.57,9.61a1.35,1.35,0,0,0,2.32.51l.94-1A4.73,4.73,0,0,0,397.76,250Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M342.92,287.7h-.45a15.68,15.68,0,0,1-5.6-1.07c-1.64-.7-2.53-1.66-2.5-2.71,0-2.05,3.59-3.51,8.26-3.42a15.63,15.63,0,0,1,5.6,1.07c1.64.7,2.53,1.66,2.51,2.71C350.69,286.26,347.37,287.7,342.92,287.7Zm-.73-6.2c-4,0-6.8,1.26-6.82,2.44,0,.6.69,1.26,1.9,1.77a14.29,14.29,0,0,0,5.23,1c4.22.08,7.21-1.22,7.24-2.44,0-.6-.7-1.26-1.9-1.77a14.29,14.29,0,0,0-5.23-1Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.19,284.41l-.59,27.2a1.61,1.61,0,0,0,1.58,1.65l39.67.86a1.63,1.63,0,0,0,1.66-1.58l.59-27.19a1.63,1.63,0,0,0-1.59-1.66l-39.67-.86A1.61,1.61,0,0,0,323.19,284.41Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M323.19,284.41l-.59,27.2a1.61,1.61,0,0,0,1.58,1.65l39.67.86a1.63,1.63,0,0,0,1.66-1.58l.59-27.19a1.63,1.63,0,0,0-1.59-1.66l-39.67-.86A1.61,1.61,0,0,0,323.19,284.41Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M362.2,285.26l-.59,27.19a1.63,1.63,0,0,0,1.58,1.66h.66a1.63,1.63,0,0,0,1.66-1.58l.59-27.19a1.63,1.63,0,0,0-1.59-1.66h-.66A1.61,1.61,0,0,0,362.2,285.26Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.42,283.69a1.6,1.6,0,0,0-1.55,1.58l-.28,12.61a1.28,1.28,0,0,1-1.31,1.26l-36.44-.79a1.3,1.3,0,0,1-1.26-1.31l.28-12.65a1.6,1.6,0,0,1,1.64-1.57l39.68.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M363.42,283.69a1.6,1.6,0,0,0-1.55,1.58l-.28,12.61a1.28,1.28,0,0,1-1.31,1.26l-36.44-.79a1.3,1.3,0,0,1-1.26-1.31l.28-12.65a1.6,1.6,0,0,1,1.64-1.57l39.68.86Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339.92,297h3a.48.48,0,0,1,.48.48v7.3a0,0,0,0,1,0,0h-3.91a0,0,0,0,1,0,0v-7.3A.48.48,0,0,1,339.92,297Z",
    transform: "translate(676.18 609.16) rotate(-178.76)",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M343.08,303h0l-3.41-.08a1,1,0,0,1-.7-.3,1,1,0,0,1-.27-.71l0-1.63a1,1,0,0,1,1-1l3.41.07a1,1,0,0,1,.69.31,1,1,0,0,1,.28.71l0,1.63A1,1,0,0,1,343.08,303Zm-3.38-3.19a.5.5,0,0,0-.49.48l0,1.63a.45.45,0,0,0,.13.35.47.47,0,0,0,.35.15l3.41.08a.47.47,0,0,0,.5-.48l0-1.64a.52.52,0,0,0-.14-.35.53.53,0,0,0-.34-.15l-3.41-.07Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M339,272.05l-.85,7.67,8.08-2.82S346.59,270,343,270Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.78 283.17 346.57 282.82 346.25 276.9 338.17 279.72 339.78 283.17",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.6000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M339,272.05l-.85,7.67,8.08-2.82S346.59,270,343,270Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "339.78 283.17 346.57 282.82 346.25 276.9 338.17 279.72 339.78 283.17",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("path", {
    d: "M346.07,187.73c-2.93,3.46-10.57,32.17-11.63,40.76s4,44.19,4,44.19l7.67-1.18s-2.4-37.17-1.34-39.62,7.71-28.8,7.71-28.8.7-5.08-.34-8.62S346.07,187.73,346.07,187.73Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M346.07,187.73c-2.93,3.46-10.57,32.17-11.63,40.76s4,44.19,4,44.19l7.67-1.18s-2.4-37.17-1.34-39.62,7.71-28.8,7.71-28.8.7-5.08-.34-8.62S346.07,187.73,346.07,187.73Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Light--inject-72"
  }, /*#__PURE__*/React.createElement("polygon", {
    points: "265.96 101.32 234.62 101.32 157.52 415.63 343.06 415.63 265.96 101.32",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "265.96 101.32 234.62 101.32 157.52 415.63 343.06 415.63 265.96 101.32",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "263.89 101.32 236.69 101.32 169.79 415.63 330.8 415.63 263.89 101.32",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--Spotlights--inject-72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M422.29,95.62H77.71a1.5,1.5,0,1,1,0-3H422.29a1.5,1.5,0,1,1,0,3Z",
    style: {
      fill: "#263238"
    }
  }), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 228.79,
    y: 81.45,
    width: 24.96,
    height: 23.34
  })), /*#__PURE__*/React.createElement("rect", {
    x: 232.69,
    y: 73.96,
    width: 34.4,
    height: 5.53,
    style: {
      fill: "#263238"
    }
  }), _polygon4 || (_polygon4 = /*#__PURE__*/React.createElement("polygon", {
    points: "230.31 110.71 245.28 110.71 240.5 104.78 231.17 104.78 230.31 110.71"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "270.54 77 270.54 110.71 241.13 110.71 239.38 107.35 231.93 107.35 230.82 110.71 230.31 110.71 230.31 77 270.54 77",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 241.82,
    y: 77,
    width: 28.72,
    height: 33.71,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.48,83.37c0,2.41-1.39,4.37-3.09,4.37a2.1,2.1,0,0,1-.43,0c-1.5-.28-2.67-2.11-2.67-4.32s1.17-4,2.67-4.32a1.58,1.58,0,0,1,.43,0C237.09,79,238.48,81,238.48,83.37Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M237.6,83.37c0,2.21-1.15,4-2.64,4.32-1.5-.28-2.67-2.11-2.67-4.32s1.17-4,2.67-4.32C236.45,79.34,237.6,81.16,237.6,83.37Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.69,83.37c0,1.06-.51,1.92-1.14,1.92s-1.14-.86-1.14-1.92.51-1.93,1.14-1.93S235.69,82.31,235.69,83.37Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 246.8,
    y: 81.45,
    width: 24.96,
    height: 23.34,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 248.86,
    y: 81.92,
    width: 22.9,
    height: 22.4,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 251.31,
    y: 83.86,
    width: 18.01,
    height: 18.51,
    transform: "translate(353.43 -167.2) rotate(90)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.71,99.16a1,1,0,0,1-.84-.47l-4.7-6.59a1.49,1.49,0,0,1,.13-1.84,1,1,0,0,1,1.55.15l3.86,5.41,6.38-8.94a1,1,0,0,1,1.56-.15,1.49,1.49,0,0,1,.12,1.85l-7.22,10.11A1,1,0,0,1,259.71,99.16Z",
    style: {
      fill: "#fff"
    }
  }), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 348.86,
    y: 81.45,
    width: 24.96,
    height: 23.34
  })), /*#__PURE__*/React.createElement("rect", {
    x: 352.76,
    y: 73.96,
    width: 34.4,
    height: 5.53,
    style: {
      fill: "#263238"
    }
  }), _polygon5 || (_polygon5 = /*#__PURE__*/React.createElement("polygon", {
    points: "350.38 110.71 365.35 110.71 360.58 104.78 351.24 104.78 350.38 110.71"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "390.62 77 390.62 110.71 361.2 110.71 359.45 107.35 352 107.35 350.89 110.71 350.38 110.71 350.38 77 390.62 77",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 361.89,
    y: 77,
    width: 28.72,
    height: 33.71,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M358.55,83.37c0,2.41-1.39,4.37-3.09,4.37a2.1,2.1,0,0,1-.43,0c-1.5-.28-2.66-2.11-2.66-4.32s1.16-4,2.66-4.32a1.58,1.58,0,0,1,.43,0C357.16,79,358.55,81,358.55,83.37Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M357.68,83.37c0,2.21-1.16,4-2.65,4.32-1.5-.28-2.66-2.11-2.66-4.32s1.16-4,2.66-4.32C356.52,79.34,357.68,81.16,357.68,83.37Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M355.77,83.37c0,1.06-.51,1.92-1.14,1.92s-1.14-.86-1.14-1.92.51-1.93,1.14-1.93S355.77,82.31,355.77,83.37Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 366.87,
    y: 81.45,
    width: 24.96,
    height: 23.34,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 368.93,
    y: 81.92,
    width: 22.9,
    height: 22.4,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 371.38,
    y: 83.86,
    width: 18.01,
    height: 18.51,
    transform: "translate(473.5 -287.27) rotate(90)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M382,93.12l4.8-5.21a1.33,1.33,0,0,0,0-1.77,1.09,1.09,0,0,0-1.63,0l-4.8,5.21-4.8-5.21a1.09,1.09,0,0,0-1.63,0,1.33,1.33,0,0,0,0,1.77l4.8,5.21-4.8,5.2a1.33,1.33,0,0,0,0,1.77,1.1,1.1,0,0,0,.82.37,1.08,1.08,0,0,0,.81-.37l4.8-5.21,4.8,5.21a1.1,1.1,0,0,0,.82.37,1.08,1.08,0,0,0,.81-.37,1.33,1.33,0,0,0,0-1.77Z",
    style: {
      fill: "#fff"
    }
  }), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 108.72,
    y: 81.45,
    width: 24.96,
    height: 23.34
  })), /*#__PURE__*/React.createElement("rect", {
    x: 112.62,
    y: 73.96,
    width: 34.4,
    height: 5.53,
    style: {
      fill: "#263238"
    }
  }), _polygon6 || (_polygon6 = /*#__PURE__*/React.createElement("polygon", {
    points: "110.23 110.71 125.21 110.71 120.43 104.78 111.1 104.78 110.23 110.71"
  })), /*#__PURE__*/React.createElement("polygon", {
    points: "150.47 77 150.47 110.71 121.05 110.71 119.31 107.35 111.86 107.35 110.75 110.71 110.23 110.71 110.23 77 150.47 77",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 121.75,
    y: 77,
    width: 28.72,
    height: 33.71,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.41,83.37c0,2.41-1.39,4.37-3.09,4.37a2,2,0,0,1-.43,0c-1.51-.28-2.67-2.11-2.67-4.32s1.16-4,2.67-4.32a1.54,1.54,0,0,1,.43,0C117,79,118.41,81,118.41,83.37Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.53,83.37c0,2.21-1.15,4-2.64,4.32-1.51-.28-2.67-2.11-2.67-4.32s1.16-4,2.67-4.32C116.38,79.34,117.53,81.16,117.53,83.37Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M115.62,83.37c0,1.06-.51,1.92-1.14,1.92s-1.14-.86-1.14-1.92.51-1.93,1.14-1.93S115.62,82.31,115.62,83.37Z",
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 126.73,
    y: 81.45,
    width: 24.96,
    height: 23.34,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 128.79,
    y: 81.92,
    width: 22.9,
    height: 22.4,
    style: {
      fill: "#fff",
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 131.23,
    y: 83.86,
    width: 18.01,
    height: 18.51,
    transform: "translate(233.35 -47.12) rotate(90)",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.87,93.12l4.8-5.21a1.33,1.33,0,0,0,0-1.77,1.09,1.09,0,0,0-1.63,0l-4.8,5.21-4.8-5.21a1.09,1.09,0,0,0-1.63,0,1.33,1.33,0,0,0,0,1.77l4.8,5.21-4.8,5.2a1.33,1.33,0,0,0,0,1.77,1.08,1.08,0,0,0,1.63,0l4.8-5.21,4.8,5.21a1.08,1.08,0,0,0,.81.37,1.1,1.1,0,0,0,.82-.37,1.33,1.33,0,0,0,0-1.77Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-2--inject-72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M230.37,403.32l.78,1.09,1.56-.67,1,4.77,6.57,9.11s2.51.4.53-4.78a4,4,0,0,1-.2-.78c-.59-3.1.7-9,.7-9l-3.61-5a8.85,8.85,0,0,0-1,.11C235.17,398.38,232.18,399.1,230.37,403.32Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M230.37,403.32l.78,1.09,1.56-.67,1,4.77,6.57,9.11s2.51.4.53-4.78a4,4,0,0,1-.2-.78c-.59-3.1.7-9,.7-9l-3.61-5a8.85,8.85,0,0,0-1,.11C235.17,398.38,232.18,399.1,230.37,403.32Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.66,398.13h0c1.21.13.15,5.47.64,8.46.43,2.68,1.6,5.2,3.3,5.46-.59-3.1,1.52-10.16,1.52-10.16l-2.9-4S237.3,398,236.66,398.13Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.66,398.13h0c1.21.13.15,5.47.64,8.46.43,2.68,1.6,5.2,3.3,5.46-.59-3.1,1.52-10.16,1.52-10.16l-2.9-4S237.3,398,236.66,398.13Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.44,417.28h1.34l.37-1.65,4.44,2h11.23s1.79-1.8-3.56-3.23a3.79,3.79,0,0,1-.76-.29c-2.85-1.34-6.91-5.86-6.91-5.86h-6.17a7.42,7.42,0,0,0-.51.89C239.24,410.5,238.08,413.35,240.44,417.28Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.91,409.14v0c.82-.91,4.52,3.08,7.24,4.44,2.42,1.2,5.14,1.74,6.35.51-2.85-1.34-7.34-7.18-7.34-7.18h-5S240.2,408.56,239.91,409.14Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M289.21,207.73l-2.68-7.08,8.37.71s2,6.46-1.37,7.35Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "287.92 193.29 294.9 196.34 294.9 201.36 286.54 200.65 287.92 193.29",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M294.53,207.87s-.36,31.54-7.36,31.54c-3.89,0-8.29-2.53-12-5.39a66.7,66.7,0,0,1-8.72-8.13l0-.11L264,211.14c6.89-.17,18.92,15.62,18.92,15.62l5.8-20Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M275.14,234a66.7,66.7,0,0,1-8.72-8.13l0-.11,2.24-5A20.13,20.13,0,0,1,275.14,234Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.68,176.16s2.19-3.78,8.46-4.43S258.73,174.44,260,184s4,14.82,4,14.82-20.2,5.28-25.88,3.38S223.66,178.91,235.68,176.16Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M274.41,344.4c-3,5.55-6.05,11.52-9,17.5-3.85,7.89-7.47,15.8-10.57,22.88-3.27,7.46-5.92,14-7.58,18.51-1.57.18-6.3-2.64-7.67-5.2a255.61,255.61,0,0,1,11-42.82c3.06-8.36,6.81-16.59,11.31-23.24-18.4-52.34-13.89-72-13.89-72l21.32-.95s3.22,19.49,5.8,39.48h0c1.35,10.48,2.51,21.1,2.94,29.12v.08A31.21,31.21,0,0,1,274.41,344.4Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.84,316.46c-2.7-8.9-4.65-16.6-6-23.21,1.37-5.16,3.3-9.59,5.93-12.25C256.75,281,260.54,295.4,256.84,316.46Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.87,384.78c-3.27,7.46-5.92,14-7.58,18.51-1.57.18-6.3-2.64-7.67-5.2a255.61,255.61,0,0,1,11-42.82C252.21,363.94,254,374.89,254.87,384.78Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M261.26,256.75s-6.2,48-9.76,71.13c-3.74,24.27-4.21,63.2-3.28,79.07-1.36.79-6.31,1.75-9,.91,0,0-12.65-49.08-4.25-77.59-7.65-56.15,3.43-69.9,3.43-69.9Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M259.19,226.52a100.51,100.51,0,0,0-20.59-14.35c.68-.08,1.38-.15,2.07-.21a100.69,100.69,0,0,1,14.22-.48c1.17.07,2.38.17,3.57.27h0C261.4,218.49,259.19,226.52,259.19,226.52Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.6,256.75c-.64-7.28-3.25-20.63-7.74-34.65-1.46-4.56,1-9.71,1-9.71s6.12-.15,6.73-.22,1.38-.15,2.07-.21a100.69,100.69,0,0,1,14.22-.48c1.17.07,2.38.17,3.57.27.38,0,4.68.08,5.05.12,0,0,5.95,6.8,6.31,12.31a95.52,95.52,0,0,1,.49,12.76c0,5-.39,11.6-.72,18.63Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.6,256.75c-.64-7.28-3.25-20.63-7.74-34.65-1.46-4.56,1-9.71,1-9.71s6.12-.15,6.73-.22,1.38-.15,2.07-.21a100.69,100.69,0,0,1,14.22-.48c1.17.07,2.38.17,3.57.27.38,0,4.68.08,5.05.12,0,0,5.95,6.8,6.31,12.31a95.52,95.52,0,0,1,.49,12.76c0,5-.39,11.6-.72,18.63Z",
    style: {
      fill: "#fff",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M238.6,256.75l31-2.09s.93,9.32.72,9.19S237.14,265,237.14,265Z",
    style: {
      fill: "#263238"
    }
  }), _polygon7 || (_polygon7 = /*#__PURE__*/React.createElement("polygon", {
    points: "238.88 257.27 269.59 255.57 269.59 258.48 238.6 260.13 238.88 257.27"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M256.17,259.67a.83.83,0,0,1-.84-.77l-.13-1.71a.81.81,0,0,1,.2-.61.83.83,0,0,1,.57-.29l3.36-.26a.83.83,0,0,1,.64.22.85.85,0,0,1,.27.62v1.79a.84.84,0,0,1-.8.84l-3.23.17Zm-.34-.81a.32.32,0,0,0,.36.31l3.23-.17a.34.34,0,0,0,.32-.34v-1.79a.33.33,0,0,0-.11-.25.35.35,0,0,0-.26-.09l-3.36.26a.33.33,0,0,0-.23.12.31.31,0,0,0-.08.24Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.12,278.07l-10.72-1.94,6.24-23.07s-1.59-5.73-3.36-12.3c-.85-3.19-1.74-6.58-2.5-9.6a79.43,79.43,0,0,1-2-9.14c-.2-3.68,3.08-9.63,3.08-9.63l7.74-1.25s7.06,7.79,7.52,22.72S241.12,278.07,241.12,278.07Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M257.3,211.14s6.73,11.72,8.28,20.38S271.4,277,271.4,277l2.32-1.16-3.23-22s1.16-25.48.26-30.71-6.76-12-6.76-12Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,210.58l.46-.41S261,211,267,218.49l-2.33,2.27,4,3.2-1.89,15.45s-6.06-20.59-8.68-25.53A18.4,18.4,0,0,0,254,210.58Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254,210.58l.46-.38S261,211,267,218.49l-2.33,2.27,4,3.2-1.89,15.45s-6.06-20.59-8.68-25.53A18.4,18.4,0,0,0,254,210.58Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.13,211.14s7.49,8.27,5.82,30l-7.33-15.62,2.65-4.26-6.2-5.82s3.25-6.17,5.55-5.56Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M241.13,211.14s7.49,8.27,5.82,30l-7.33-15.62,2.65-4.26-6.2-5.82s3.25-6.17,5.55-5.56Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.72,213.49,255,223.78l-13.54-11.84c2.86-3.16,1.06-11.48-.34-16l3.84,2.87,5.7,4.27a10.51,10.51,0,0,0,.28,3.51c.43,1.81,1.2,3.52,2.06,3.88Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.94,206.57c-2.28-.51-5.26-2.87-5.74-5.19a11.28,11.28,0,0,1-.24-2.59l5.7,4.27A10.51,10.51,0,0,0,250.94,206.57Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.13,209.34s5.79,4.47,12.59,13.91c0,0,.61-9.42-1.72-12.8l.48-.58a22.62,22.62,0,0,1,9,7.11L258,215.56l-3.07,8.3-9.24-7.63-6.22,1.08S239.74,211.18,242.13,209.34Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M242.13,209.34s5.79,4.47,12.59,13.91c0,0,.61-9.42-1.72-12.8l.48-.58a22.62,22.62,0,0,1,9,7.11L258,215.56l-3.07,8.3-9.24-7.63-6.22,1.08S239.74,211.18,242.13,209.34Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M236.91,186.88c1.64,7.33,2.17,10.47,6.51,13.87,6.52,5.11,15.14,2,15.71-5.57.52-6.8-2.25-17.66-9.94-19.84A9.64,9.64,0,0,0,236.91,186.88Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.38,187.78c.11.63.53,1.1.92,1.05s.64-.58.53-1.2-.53-1.09-.93-1S246.27,187.16,246.38,187.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.13,186.71c.11.62.52,1.09.92,1s.63-.58.52-1.2-.52-1.09-.92-1.05S254,186.08,254.13,186.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M254.48,185.55l1.39-.58S255.32,186.21,254.48,185.55Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252,188.33a18.54,18.54,0,0,0,2.88,3.73,2.48,2.48,0,0,1-2.1.65Z",
    style: {
      fill: "#d58745"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M244.54,184a.32.32,0,0,0,.25-.12,2.7,2.7,0,0,1,2.36-1,.34.34,0,0,0,.4-.3.4.4,0,0,0-.33-.42,3.38,3.38,0,0,0-3,1.23.36.36,0,0,0,.06.51A.39.39,0,0,0,244.54,184Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M256.58,182.27a.35.35,0,0,0,.26-.08.36.36,0,0,0,0-.51,3.86,3.86,0,0,0-3.08-1.5.33.33,0,0,0-.3.39.39.39,0,0,0,.41.34,3.09,3.09,0,0,1,2.42,1.22A.42.42,0,0,0,256.58,182.27Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M246.73,186.63l1.39-.59S247.58,187.29,246.73,186.63Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240.67,191.13s3.61-5.26.86-13c0,0,8.16-4,14.34,2.08,0,0-5.75-10.08-17.76-5.25s-3,16.36-1.46,17.32S240.67,191.13,240.67,191.13Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M235.44,193.22a6,6,0,0,0,4,2.34c2,.24,2.62-1.81,1.69-3.69-.83-1.7-2.89-3.86-4.76-3.23S234.21,191.61,235.44,193.22Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M253.21,194.42a20.55,20.55,0,0,0-1,2.9,4.93,4.93,0,0,1-.54,0c-2.44-.24-3.48-1.16-3.91-2.11a3.21,3.21,0,0,1-.24-1.47,3.1,3.1,0,0,1,.16-.84,11.48,11.48,0,0,0,4.68,1.47C252.89,194.4,253.21,194.42,253.21,194.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M252.38,194.32l-.31.85c-2.3-.24-3.88-.71-4.53-1.48a3.1,3.1,0,0,1,.16-.84A11.48,11.48,0,0,0,252.38,194.32Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M251.69,197.27c-2.44-.24-3.48-1.16-3.91-2.11a8,8,0,0,1,2.65.81A2.94,2.94,0,0,1,251.69,197.27Z",
    style: {
      fill: "#de5753"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M234.7,239a3.56,3.56,0,0,1-1.42,1.77c-.85-3.19-1.74-6.58-2.5-9.6,2-2.4,3.66-4.4,3.66-4.4S236.72,233.85,234.7,239Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M231.88,212.39c-4.25.52-17.24,32.79-16.46,37.89s28.72,2.78,28.72,2.78v-7.77L227.83,242l5.64-11.08A28.09,28.09,0,0,0,234.7,221,22.41,22.41,0,0,0,231.88,212.39Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.1,264.92l-21.44-2.6a1.43,1.43,0,0,1-1.27-1.64l3.77-27.57a1.54,1.54,0,0,1,1.72-1.27l21.44,2.6a1.42,1.42,0,0,1,1.27,1.63l-3.77,27.58A1.54,1.54,0,0,1,249.1,264.92Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M249.1,264.92l-21.44-2.6a1.43,1.43,0,0,1-1.27-1.64l3.77-27.57a1.54,1.54,0,0,1,1.72-1.27l21.44,2.6a1.42,1.42,0,0,1,1.27,1.63l-3.77,27.58A1.54,1.54,0,0,1,249.1,264.92Z",
    style: {
      fill: "#fff",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M248.21,264.81l-20.55-2.49a1.43,1.43,0,0,1-1.27-1.64l3.77-27.57a1.54,1.54,0,0,1,1.72-1.27l20.55,2.49a1.42,1.42,0,0,1,1.26,1.64l-3.76,27.57A1.56,1.56,0,0,1,248.21,264.81Z",
    style: {
      fill: "#fff",
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M240,246a2.39,2.39,0,0,0-2.67,2,2.23,2.23,0,0,0,2,2.54,2.41,2.41,0,0,0,2.66-2A2.21,2.21,0,0,1,240,246Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M247.27,235.93,236,234.56a1.32,1.32,0,0,1-1.13-1l-.35-1.43,15,1.82-.77,1.29A1.43,1.43,0,0,1,247.27,235.93Z",
    style: {
      opacity: 0.30000000000000004
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M250.12,244.34l-6.38,1.83-1.34,4.22c.61,3.44,7.21,2,7.21,2l1.36.85a1.83,1.83,0,0,0,2.77-1.23l.7-4a1.82,1.82,0,0,0-.68-1.76l-2-1.57A1.82,1.82,0,0,0,250.12,244.34Z",
    style: {
      fill: "#ebb376"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M218.88,237c-2.24,6.13-3.74,11.49-3.46,13.33.77,5.1,28.72,2.78,28.72,2.78v-7.77L227.83,242Z",
    style: {
      fill: "#407BFF"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--speech-bubble--inject-72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M279.86,153.82H267.59a4.22,4.22,0,0,0-4.22,4.22V170a4.21,4.21,0,0,0,4.22,4.21h2.89l-.71,4.46,3.54-4.46h6.55a4.21,4.21,0,0,0,4.21-4.21V158A4.22,4.22,0,0,0,279.86,153.82Z",
    style: {
      fill: "#407BFF"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M269.46,161.61c1.07-1.78,3.15-1.13,4.25.23,1.05-1.39,3.12-2.09,4.23-.34,1.87,2.95-1.87,5.76-3.64,6.86l-.51.32-.51-.3C271.48,167.32,267.67,164.61,269.46,161.61Z",
    style: {
      fill: "#fff"
    }
  })), /*#__PURE__*/React.createElement("g", {
    id: "freepik--character-1--inject-72"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M138.78,207.38c6.27,5.83,7,26,7.52,34.57.31,5,1.08,10.35,1.78,15.43.74,5.24,1.47,10.53,2.16,15.8a2.63,2.63,0,0,1-5.09,1.24c-1.81-5.1-3.42-10.23-4.82-15.45a124.26,124.26,0,0,1-4-20.11c-1.07-7.39-2-15.21-4.2-22.28a12.92,12.92,0,0,0-.66-1.53c.07,0,.12.14.22.19-5.06-4.82,1.73-12.39,7.08-7.86Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.78,207.38c6.27,5.83,7,26,7.52,34.57.31,5,1.08,10.35,1.78,15.43.74,5.24,1.47,10.53,2.16,15.8a2.63,2.63,0,0,1-5.09,1.24c-1.81-5.1-3.42-10.23-4.82-15.45a124.26,124.26,0,0,1-4-20.11c-1.07-7.39-2-15.21-4.2-22.28a12.92,12.92,0,0,0-.66-1.53c.07,0,.12.14.22.19-5.06-4.82,1.73-12.39,7.08-7.86Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M151.06,272.73l3.76,6.57-8.37.62s-3-6.06.19-7.48Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.61 286.79 147.24 284.88 146.45 279.92 154.82 279.3 154.61 286.79",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.31,217.12c-5.32,4.41-11.86,9.35-15.4,15,0-.37-.12-.47-.08-.29,1.13,2.8,3.48,5.15,5.54,7.54,2.81,3.08,5.86,6.18,8.87,9.2a2.65,2.65,0,0,1-3.19,4.15,73.77,73.77,0,0,1-16.31-12.24c-3-3.06-5.53-7.25-3.87-11.69,1.5-4.42,4.7-7.94,7.73-11.13a87.44,87.44,0,0,1,10.35-9c5.72-4,11.77,4.09,6.36,8.47Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.31,217.12c-5.32,4.41-11.86,9.35-15.4,15,0-.37-.12-.47-.08-.29,1.13,2.8,3.48,5.15,5.54,7.54,2.81,3.08,5.86,6.18,8.87,9.2a2.65,2.65,0,0,1-3.19,4.15,73.77,73.77,0,0,1-16.31-12.24c-3-3.06-5.53-7.25-3.87-11.69,1.5-4.42,4.7-7.94,7.73-11.13a87.44,87.44,0,0,1,10.35-9c5.72-4,11.77,4.09,6.36,8.47Z",
    style: {
      fill: "#fff",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.92,254.32s.46,7.83,4.29,21.55a217.41,217.41,0,0,0,8.72,24.95c1.91,4.59,4.1,9.46,6.61,14.59,1.13,2.33,2.34,4.7,3.61,7.14,1.47,41.54,24.78,83.78,24.78,83.78,1.29.67,5.8-.06,5.77-1.37-3.45-5.49-10.25-58.72-14.63-84-.27-3.43-.66-7.11-1.15-10.91-1.28-10.19-3.17-21.28-5-31-2.89-15.35-5.65-27.4-5.65-27.4l-7.69.75Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.92,254.32s.46,7.83,4.29,21.55a217.41,217.41,0,0,0,8.72,24.95c1.91,4.59,4.1,9.46,6.61,14.59,1.13,2.33,2.34,4.7,3.61,7.14,1.47,41.54,24.78,83.78,24.78,83.78,1.29.67,5.8-.06,5.77-1.37-3.45-5.49-10.25-58.72-14.63-84-.27-3.43-.66-7.11-1.15-10.91-1.28-10.19-3.17-21.28-5-31-2.89-15.35-5.65-27.4-5.65-27.4l-7.69.75Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.76,311.83h0c.62,4.47,1.41,9.24,2.4,14.34-8.33,27.79,8.79,82,8.79,82,2.9.57,5.47.19,6.77-.78-3.23-16.34-.91-58.82,1.6-84.21.22-2.3.5-4.84.81-7.54.52-4.58,1.13-9.63,1.79-14.84,1.1-8.73,2.35-17.92,3.47-26.06,1.37-9.85,2.57-18.18,3.17-22.36.27-1.84.42-2.88.42-2.88l-24.05,2.6s-6.11,6.86-7,28.27A175,175,0,0,0,101.76,311.83Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.76,311.83h0c.62,4.47,1.41,9.24,2.4,14.34-8.33,27.79,8.79,82,8.79,82,2.9.57,5.47.19,6.77-.78-3.23-16.34-.91-58.82,1.6-84.21.22-2.3.5-4.84.81-7.54.52-4.58,1.13-9.63,1.79-14.84,1.1-8.73,2.35-17.92,3.47-26.06,1.37-9.85,2.57-18.18,3.17-22.36.27-1.84.42-2.88.42-2.88l-24.05,2.6s-6.11,6.86-7,28.27A175,175,0,0,0,101.76,311.83Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M135.36,203.2c7.67,2.56,8.21,8,12.6,19.49A16.89,16.89,0,0,1,135.38,230S124.4,209.53,135.36,203.2Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M148,222.68a17.06,17.06,0,0,1-9.11,6.68,13.59,13.59,0,0,1-3.47.65l-.17-.34c-.87-1.72-4.75-9.74-4.72-16.8,0-3.93,1.24-7.58,4.87-9.68C143,205.75,143.57,211.24,148,222.68Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M143.69,227a17.22,17.22,0,0,1-4.84,2.36,37.74,37.74,0,0,1-3.6-11.23,5.93,5.93,0,0,1,5.8,3A22.17,22.17,0,0,1,143.69,227Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M130.74,170.87s7.13,17.83,0,33.35-27.14,6.2-29.12,2.48,2.65-11.3,2.65-18.24-1.68-10.72-.42-16.42S130.74,170.87,130.74,170.87Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.76,311.83h0a74.91,74.91,0,0,0,20.37,3.83c.52-4.58,1.13-9.63,1.79-14.84,1.91,4.59,4.1,9.46,6.61,14.59a50.13,50.13,0,0,0,18.38-5.33c-1.28-10.19-3.17-21.28-5-31a29.88,29.88,0,0,0-8.17-3.29,35.63,35.63,0,0,0-8.34-1,62.66,62.66,0,0,0-12.19,1.11,76.71,76.71,0,0,0-15.31,4.52A175,175,0,0,0,101.76,311.83Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.62,203.78a151.88,151.88,0,0,1,3.11,16.07c.43,3,.85,6.37,1.19,10a188.86,188.86,0,0,1,.8,22.21h31.67s5-37-3.26-49C135.13,203.09,118.9,195.44,101.62,203.78Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M101.62,203.78a151.88,151.88,0,0,1,3.11,16.07c.43,3,.85,6.37,1.19,10a188.86,188.86,0,0,1,.8,22.21h31.67s5-37-3.26-49C135.13,203.09,118.9,195.44,101.62,203.78Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.5
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M104.73,219.85c.43,3,.85,6.37,1.19,10a24.7,24.7,0,0,0,.9-17.08Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,197.71c-9.93,0-11.18,8.17-11.18,8.17l4.64-2L125.11,213l3.35-9.21,4.21.78S126.63,197.72,118,197.71Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,197.71c-9.93,0-11.18,8.17-11.18,8.17l4.64-2L125.11,213l3.35-9.21,4.21.78S126.63,197.72,118,197.71Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.66,212.46l-12.8-11.14c3.11-3.19,1.52-12,.22-16.75l9.71,7.8c-.65,3.72-.49,7.68,4.94,8.95C126.73,201.32,124.65,212.43,124.66,212.46Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.66,212.46l-12.8-11.14c3.11-3.19,1.52-12,.22-16.75l9.71,7.8c-.65,3.72-.49,7.68,4.94,8.95C126.73,201.32,124.65,212.43,124.66,212.46Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M116,187.76l5.75,4.61a14.85,14.85,0,0,0-.26,2.64c-2.06-.3-5-2.54-5.4-4.67A7.26,7.26,0,0,1,116,187.76Z",
    style: {
      opacity: 0.1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,175c1.45,7.73,1.9,11,6.31,14.73,6.63,5.57,15.74,2.62,16.61-5.26.79-7.09-1.72-18.53-9.68-21.08A10.07,10.07,0,0,0,108,175Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M108,175c1.45,7.73,1.9,11,6.31,14.73,6.63,5.57,15.74,2.62,16.61-5.26.79-7.09-1.72-18.53-9.68-21.08A10.07,10.07,0,0,0,108,175Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M114.64,169.39c-4.26,5.5,4.5,11.83-4.26,11.46s-5.2-12.73,0-15.54S114.64,169.39,114.64,169.39Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.24,176.26c.09.65.51,1.16.93,1.13s.68-.59.58-1.24-.51-1.16-.92-1.13S120.14,175.6,120.24,176.26Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.13,175.79c.09.66.51,1.16.93,1.13s.68-.59.59-1.24-.51-1.16-.93-1.13S128,175.14,128.13,175.79Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M128.54,174.6,130,174S129.4,175.32,128.54,174.6Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M126.09,177a19.42,19.42,0,0,0,2.88,4,2.63,2.63,0,0,1-2.22.61Z",
    style: {
      opacity: 0.2
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.41,184.32a5.61,5.61,0,0,0,1.09,0,.18.18,0,0,0,.16-.21.2.2,0,0,0-.21-.17,5.52,5.52,0,0,1-4.43-1.72.19.19,0,0,0-.27,0,.19.19,0,0,0,0,.27A5.81,5.81,0,0,0,123.41,184.32Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.25,182.42a5.4,5.4,0,0,0,3.28,2.88c1.8.48,2.58-1.58,2-3.64-.54-1.86-2.12-4.34-3.88-3.89S106.34,180.61,107.25,182.42Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118,172.74a.32.32,0,0,0,.27-.11,2.82,2.82,0,0,1,2.5-1,.36.36,0,0,0,.43-.3.43.43,0,0,0-.33-.46,3.55,3.55,0,0,0-3.18,1.18.39.39,0,0,0,0,.54A.34.34,0,0,0,118,172.74Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M129.9,172a.38.38,0,0,0,.27-.09.38.38,0,0,0,0-.54,4,4,0,0,0-3.27-1.45.34.34,0,0,0-.3.42.41.41,0,0,0,.44.34,3.23,3.23,0,0,1,2.58,1.18A.42.42,0,0,0,129.9,172Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M120.65,175.07l1.47-.57S121.51,175.79,120.65,175.07Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M118.34,165.51s-2.33,10.36-10,11.52-5.83-10.09,4.33-14.23,18.4,4.1,18.87,6.32a3.79,3.79,0,0,1-1.57,3.62S126.31,165.71,118.34,165.51Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.25,182.42a5.4,5.4,0,0,0,3.28,2.88c1.8.48,2.58-1.58,2-3.64-.54-1.86-2.12-4.34-3.88-3.89S106.34,180.61,107.25,182.42Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M112.36,415.28h1.34l.37-1.65,4.44,2h11.24s1.78-1.8-3.57-3.23a4.86,4.86,0,0,1-.76-.29c-2.85-1.34-6.91-5.86-6.91-5.86h-6.17a8.61,8.61,0,0,0-.5.89C111.16,408.5,110,411.35,112.36,415.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.84,407.14v0c.81-.91,4.52,3.08,7.23,4.44,2.42,1.2,5.15,1.74,6.35.51-2.85-1.34-7.34-7.18-7.34-7.18h-5S112.13,406.56,111.84,407.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M111.84,407.14v0c.81-.91,4.52,3.08,7.23,4.44,2.42,1.2,5.15,1.74,6.35.51-2.85-1.34-7.34-7.18-7.34-7.18h-5S112.13,406.56,111.84,407.14Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.18,415.28h1.34l.37-1.65,4.44,2h11.23s1.79-1.8-3.56-3.23a4.51,4.51,0,0,1-.76-.29c-2.85-1.34-6.91-5.86-6.91-5.86h-6.17a7.42,7.42,0,0,0-.51.89C158,408.5,156.82,411.35,159.18,415.28Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.65,407.14v0c.82-.91,4.52,3.08,7.24,4.44,2.42,1.2,5.14,1.74,6.35.51-2.85-1.34-7.34-7.18-7.34-7.18h-5S158.94,406.56,158.65,407.14Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M158.65,407.14v0c.82-.91,4.52,3.08,7.24,4.44,2.42,1.2,5.14,1.74,6.35.51-2.85-1.34-7.34-7.18-7.34-7.18h-5S158.94,406.56,158.65,407.14Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M138.69,249.52H106.76l-.86,4.11s-11.72,16.24-5.78,56.72c0,0,25.69,3,49.87-2.23,0,0-5.43-41.58-11.1-55.15Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.28 253.06 105.57 253.06 106.22 250 116.28 250 116.28 253.06",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.74 250 138.95 250 139.23 253.06 135.74 253.06 135.74 250",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.32,
    y: 250,
    width: 17.35,
    height: 3.05,
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "116.28 253.06 105.57 253.06 106.22 250 116.28 250 116.28 253.06",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "135.74 250 138.95 250 139.23 253.06 135.74 253.06 135.74 250",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 117.32,
    y: 250,
    width: 17.35,
    height: 3.05,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("rect", {
    x: 124.51,
    y: 249.77,
    width: 5.86,
    height: 3.52,
    rx: 0.56,
    transform: "translate(254.88 503.06) rotate(180)",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.6,203.06c-3.81.2-10.73,6.77-16.54,14.24A87.4,87.4,0,0,0,97,227.39l11-7.78S109.3,207.35,103.6,203.06Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M103.6,203.06c-3.81.2-10.73,6.77-16.54,14.24A87.4,87.4,0,0,0,97,227.39l11-7.78S109.3,207.35,103.6,203.06Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.8
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.84,215.76a.63.63,0,1,0,.63-.62A.63.63,0,0,0,124.84,215.76Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 126.71,
    cy: 224.92,
    r: 0.62,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.44,
    cy: 234.48,
    r: 0.62,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 127.44,
    cy: 244.64,
    r: 0.62,
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.6000000000000001
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.53,255.72l-.41-2.41a2.85,2.85,0,0,0-1.57-2.08l-3.87-1.87a5.31,5.31,0,0,0-4.86.13l-.93.52c.41,4,3.83,8.1,3.83,8.1l.85,1.27a2.36,2.36,0,0,0,3.28.73l2.54-1.65A2.72,2.72,0,0,0,110.53,255.72Z",
    style: {
      fill: "#263238"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M110.53,255.72l-.41-2.41a2.85,2.85,0,0,0-1.57-2.08l-3.87-1.87a5.31,5.31,0,0,0-4.86.13l-.93.52c.41,4,3.83,8.1,3.83,8.1l.85,1.27a2.36,2.36,0,0,0,3.28.73l2.54-1.65A2.72,2.72,0,0,0,110.53,255.72Z",
    style: {
      fill: "#fff",
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }), /*#__PURE__*/React.createElement("g", {
    style: {
      isolation: "isolate",
      opacity: 0.7000000000000001
    }
  }, /*#__PURE__*/React.createElement("path", {
    d: "M151.06,272.73l3.76,6.57-8.37.62s-3-6.06.19-7.48Z",
    style: {
      fill: "#fff"
    }
  }), /*#__PURE__*/React.createElement("polygon", {
    points: "154.61 286.79 147.24 284.88 146.45 279.92 154.82 279.3 154.61 286.79",
    style: {
      fill: "#fff"
    }
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmployees);
export default __webpack_public_path__ + "static/media/employees.d2c61f2b7ee5c8167628d453320e3d40.svg";
export { ForwardRef as ReactComponent };